import styled from "styled-components"
import {H2} from "@irati/ui/src/Typography"
import padding from "@irati/ui/src/global/padding"

export default styled(H2)`
  margin-bottom: ${padding.base};
`
